export default __webpack_public_path__ + "static/media/icon.d73db5bd.png";